<template>
    <div class="app-container mt-5">
        <div class="page-title mb-3">
            <router-link to="/configuration">
                <span class="breadcrumb-link">
                    <v-icon class="breadcrumb-link-icon">settings</v-icon> Configuration du compte
                </span>
            </router-link>
            <v-icon>keyboard_arrow_right</v-icon>
            <span class="breadcrumb-item">
                <v-icon class="breadcrumb-item-icon">assignment</v-icon> Mes contrats
            </span>
        </div>

        <div v-if="!contracts.length">
            <v-alert type="info" text class="mt-5 mb-5 form-container mr-auto ml-auto" border="right" colored-border>
                <p>
                    Aucun contrat en cours de validité n'est associé à votre compte.
                </p>
            </v-alert>
        </div>

        <div v-else>
            <div class="row">
              <div class="col-4" v-for="contract in contracts">
                <v-card class="p-4">
                  <h4>{{ contract.contract_offer.label }}</h4>
                  <table>
                    <tr>
                      <td style="padding-right: 30px">Date de début</td>
                      <td>{{ formatDate(contract.valid_from, false) }}</td>
                    </tr>
                    <tr>
                      <td style="padding-right: 30px">Date de fin</td>
                      <td>{{ formatDate(contract.valid_through, false) }}</td>
                    </tr>
                  </table>
                  <v-card class="bg-light">
                  <v-card-title class="text-center mt-6" v-if="contract.contract_offer.options.length > 0">
                    Options</v-card-title>
                  <ul class="list-group list-group-flush bg-light" v-for="option in contract.contract_offer.options">
                    <li class="list-group-item bg-light">{{ option.label }}</li>
                  </ul>
                  </v-card>
                </v-card>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "ContractConfig",
    data() {
        return {
            subscription: {},
            contracts: [],
        }
    },
    methods: {
        getContracts() {
            this.contracts = this.account.current_contracts

            if (this.contracts.length) {

                this.subscription = this.contracts.filter( contract => {
                  return contract.contract_offer.code === 'USKA_FREEMIUM'
                })
            }
        },
    },
    computed: {
        ...mapState('account', ['account', 'user'])
    },
    created() {
        this.getContracts()
    }
}
</script>